import { createSelector } from '@reduxjs/toolkit';

import { AppStateType } from '@lib/core/service/types/appStateType';
import { TModalTypes } from '@lib/tools/modals/slice';

const selectModalState = (modalName: TModalTypes) =>
  createSelector(
    (state: AppStateType) => state?.modals?.modalState,
    modalState => modalState[modalName] || false,
  );

export { selectModalState };
